import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../reducers";
import { combineLatest, Observable } from "rxjs";
import { currentUser, isLoggedIn } from "./mad-auth.store";
import { map, tap } from "rxjs/operators";
import { slugify } from "../v2/utils/slugify";

@Injectable()
export class IsSignedInGuard implements CanActivate
{
  constructor(
    private _store$: Store<AppState>,
    private _router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([
      this._store$.select(isLoggedIn),
      this._store$.select(currentUser)
    ]).pipe(
      tap(([isLoggedIn, user]) => {
        if (isLoggedIn && user) {
          this._router.navigateByUrl(`/org/${slugify(user.provider.account_name)}/dashboard`)
        }
      }),
      map(([loggedIn, _]) => {
        return !loggedIn
      })
    )
  }
}